import { cn } from '../lib/cn';

/** AMG tile + "Support" wordmark. The tile colour is the AMG mulberry from the company mark. */
export function BrandMark({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <span
        aria-hidden
        className="grid h-8 w-10 place-items-center rounded-[8px] bg-[#9a4269] text-white shadow-[inset_0_1px_0_rgb(255_255_255/0.2),0_1px_2px_rgb(0_0_0/0.15)]"
      >
        <span className="text-[0.6875rem] font-semibold tracking-[0.06em]">AMG</span>
      </span>
      {compact ? (
        <span className="sr-only">AMG Support</span>
      ) : (
        <span className="text-[0.9375rem] font-semibold tracking-[-0.01em] text-ink">
          <span className="sr-only">AMG </span>Support
        </span>
      )}
    </span>
  );
}
